import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue,orderByChild,startAt} from "firebase/database";

const useObtenerActivos = () => {
  function toTimestamp(strDate){
    var datum = Date.parse(strDate);
    return datum;
  }
    const [conductores, cambiarConductores] = useState([]);
    
    useEffect(() => {
        //const viajes = [];
        //cambiarConductores([])
        var date = new Date()
        var numberOfMlSeconds = date.getTime();
        var addMlSeconds4 = 60 * 60000 * 1; // 1 horas de programacion
        var seishorasantes = new Date(numberOfMlSeconds - addMlSeconds4);
        var inicio=toTimestamp(seishorasantes)
        console.log("6 horas antes")
        console.log(inicio)
        const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/conductores_tracking'),orderByChild('time'),startAt(inicio));
        console.log("consulta base conductores activos")
        return onValue(consulta, (snapshot) => {
          cambiarConductores([])
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            cambiarConductores((conductores) => [...conductores, {...childData, id: childKey}]);
            });
    },{
      //  onlyOnce: true
      });
    }, []);
    
    return (conductores);
}

export default useObtenerActivos;